var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4589)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0C27.9415 0 36 8.05852 36 18C36 27.9415 27.9415 36 18 36C8.05852 36 0 27.9415 0 18C0 8.05852 8.05852 0 18 0Z",
    fill: "#39AE41"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9999 26.2842C16.5339 26.2842 15.0911 25.894 13.829 25.1564C13.6258 25.0375 13.3811 25.0059 13.154 25.0678L10.4097 25.8208L11.3659 23.715C11.496 23.4288 11.4623 23.0948 11.2787 22.8396C10.2557 21.4228 9.71569 19.7486 9.71569 18C9.71569 13.4318 13.4317 9.71575 17.9999 9.71575C22.5681 9.71575 26.2841 13.4318 26.2841 18C26.2841 22.5682 22.5681 26.2842 17.9999 26.2842ZM17.9999 7.96216C12.4649 7.96216 7.9628 12.465 7.9628 18C7.9628 19.9469 8.51476 21.8165 9.56593 23.4393L8.04085 26.7982C7.90022 27.1083 7.95155 27.4711 8.17163 27.7298C8.34108 27.9274 8.58647 28.0378 8.8389 28.0378C9.40421 28.0378 12.4874 27.0689 13.2721 26.853C14.7226 27.6293 16.349 28.0378 17.9999 28.0378C23.5342 28.0378 28.0377 23.5343 28.0377 18C28.0377 12.465 23.5342 7.96286 17.9999 7.96216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3962 19.1735C20.0165 19.3289 19.774 19.9237 19.5279 20.2275C19.4013 20.3829 19.2508 20.4075 19.0568 20.3294C17.6308 19.7613 16.5375 18.8093 15.7507 17.4972C15.6171 17.294 15.641 17.133 15.802 16.9439C16.0397 16.664 16.3385 16.3462 16.4025 15.9686C16.5452 15.1347 15.4547 12.5465 14.014 13.7193C9.86904 17.0972 20.9285 26.0557 22.9247 21.2104C23.4893 19.8365 21.0262 18.9154 20.3962 19.1735Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/Whatsapp.d182c59cd6f018bdfde24658d44f053a.svg";
export { ForwardRef as ReactComponent };